import React from "react";

import {
  Box,
  Theme,
  Typography,
  TypographyProps,
  useMediaQuery,
} from "@mui/material";

export const Hero2Text: React.FC<
  TypographyProps<React.ElementType, { component?: React.ElementType }>
> = ({ children, component = "h2", ...defaultProps }) => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.only("xs")
  );

  return (
    <Typography component={component}>
      <Box
        fontSize={isMobile ? 21 : 24}
        lineHeight={isMobile ? "31px" : "34.99px"}
        fontWeight={600}
        letterSpacing={0.5}
        component="span"
        display="block"
        {...defaultProps}
      >
        {children}
      </Box>
    </Typography>
  );
};
